export default class IHElevation {
  
  static extended(core) {
    
    $(core).on('ready', () => {
  
      core.initElevation();
      
      if (!core.options.show_elevation) {
        $('.js-elevation-chart').hide();
        return;
      }
      
      core.elevator = core.getService('Elevation');
      core.notes = $('.js-elevation-chart-notes').hide().clone();
      
    });
  
    $(core).on('ihBeforeRequestPlaces', () => {
      
      if (!core.options.show_elevation) {
        return;
      }
      
      if (core.pathMarker) {
        core.pathMarker.setMap(null);
      }
      
    });
    
    $(core).on('ihAfterDirection', (event, response) => {
      
      if (!core.options.show_elevation) {
        return;
      }
      
      if (core.pathMarker){
        core.pathMarker.setMap(null);
      }
      
      core.drawPath(response.routes[0].overview_path, core.getLastClickedPlace());
      // var p = core.getLastClickedPlace();
      // notes.find('img').each(function(){
      //   var s = $(this).attr('ih-src');
      //   if (s){
      //     $(this).attr('src', s.replace('{{type}}', p.type));
      //   }
      // });
      // $('.js-elevation-chart').after(notes.show());
    });
    
  }
  
  initElevation(){
    this.chart = null;
    this.elevator = null;
    this.notes = null;
    this.pathMarker = null;
    this.result = null;
  }
  
  chartMouseover(obj){
    
    let index;
    
    if (obj) {
      index = obj.row;
    } else {
      let selection = this.chart.getSelection();
      if (selection && selection[0]) {
        index = selection[0].row;
      }
    }
    
    if (this.pathMarker) {
      this.pathMarker.setMap(null);
    }
    
    if (this.result && this.result[index]) {
      
      let latlng = new google.maps.LatLng(this.result[index].location.lat(), this.result[index].location.lng());
      
      this.pathMarker = new google.maps.Marker({
        map: this.map.getMap(),
        position: latlng,
        zIndex: 100,
        icon: this.icon_file_path + '../direction.png'
      });
      
    }
  }
  
  /**
   * 最上位で切り捨て
   * @param  {[type]} num [description]
   * @return {[type]}     [description]
   */
  highFloor(num){
    
    let base;
    
    for (let i = 0; i <= 10; i++) {
      
      if (Math.pow(10, i) > num) {
        base = Math.pow(10, i - 2);
        return Math.floor(num / base) * base;
      }
      
    }
    
    return num;
    
  }
  
  drawPath(path, place){
    
    let sample = 120;
    let chartDOM = $('.js-elevation-chart');
    let chartDiv = chartDOM.get(0);
    let width = chartDOM.width();
    let distance = place.distance * 1000;
    
    chartDiv.style.display = 'block';
    this.chart = new google.visualization.ColumnChart(chartDiv);
    
    let pathRequest = {
      path: path,
      samples: sample
    };
    
    if (!this.elevator) {
      return;
    }
    
    let that = this;
    this.elevator.getElevationAlongPath(pathRequest, (results, status) => {
      
      that.result = results;
      
      if (status !== google.maps.ElevationStatus.OK) {
        return;
      }
      
      let data = new google.visualization.DataTable();
      data.addColumn('string', '基準位置からの距離');
      data.addColumn('number', '標高');
      
      for (let i = 0; i < results.length; i++) {
        
        let text = that.highFloor(i / sample * distance);
        
        data.addRow([
          text + "",
          Math.floor(results[i].elevation)
        ]);
      
      }
      
      let formatter = new google.visualization.ColorFormat({colorNegative: 'green'});
      formatter.format(data, 0);
      that.chart.draw(data, {
        width: width,
        height: 200,
        legend: 'none',
        colors:['#D6D0C6'],
        chartArea: {
          width: width - 75,
          left: 60,
          backgroundColor: {
            stroke: '#666',
            strokeWidth: 1
          }
        },
        vAxis: {
          title: '標高(m)',
          titleTextStyle: {
            fontSize: '13',
            italic: false
          },
          textStyle: {
            fontSize: '13'
          }
        },
        hAxis: {
          title: '基準位置からの距離(m)',
          showTextEvery: Math.floor(sample / 4) - 1,
          titleTextStyle: {
            fontSize: '13',
            italic: false
          },
          textStyle: {
            fontSize: '13'
          }
          // ticks: [{v:32, f:'thirty two'}, {v:64, f:'sixty four'}]
        },
        tooltip: {
          trigger: 'none',
        },
        bar: {
          groupWidth: '100%'
        }
      });
    });
    
    // 既定のselect挙動を消したいけどremoveAllListenersで消えない
    // google.visualization.events.removeAllListeners(chart);
    google.visualization.events.addListener(this.chart, 'onmouseover', obj => this.chartMouseover(obj));
    google.visualization.events.addListener(this.chart, 'select', obj => this.chartMouseover(obj));
  }
  
  // //  -----------------------------------------
  // function initialize() {
  //   var mapDiv = document.getElementById('canvas');
  //   var latlng = new google.maps.LatLng(35.710058, 139.810718);
  //   var route = [] ; var rn=0;
  //   var myOptions = {
  //     zoom: 8,
  //     center: latlng,
  //     mapTypeId: google.maps.MapTypeId.ROADMAP,
  //     mapTypeControl: true,
  //     mapTypeControlOptions: {style: google.maps.MapTypeControlStyle.DROPDOWN_MENU},
  //     navigationControl: true,
  //     navigationControlOptions: {style: google.maps.NavigationControlStyle.SMALL},
  //     scaleControl: true
  //   };
  //   map = new google.maps.Map(mapDiv, myOptions);
  
  
  //   google.maps.event.addListener(map, 'click', function(e) {
  //     route.push(e.latLng);
  //     rn= rn+1 ; //  window.alert (rn);
  
  //     if( route.length > 2 ){
  //       route[0]=route[1]; route[1]=route[2]; route.pop(e.latLng);
  //     }
  //     markers[rn] = new google.maps.Marker({
  //       position: e.latLng,
  //       visible:true,
  //       map: map
  //     });
  
  //     var roadPath = new google.maps.Polyline({
  //       path: route,
  //       strokeColor: '#0000ee',
  //       strokeOpacity: 0.5,
  //       strokeWeight: 3
  //     });
  
  //     roadPath.setMap(map);
  
  //     drawPath(route);
  
  //     markers[rn-2].setMap(null);
  //   });
  // }
  
  //  -----------------------------------------
  
}



// WEBPACK FOOTER //
// ./map/js/ih/modules/IHElevation.js